module.exports = "/assets/b40bc013a0c38c4b005b6fbe7ecf356b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/U5.png
// module id = 1879
// module chunks = 0